import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

import { isServer } from '../../../../../util/sdkLoader';
import { FadeAnimation, SlideAnimation } from '../../../../../components/Animations';
import { IconAdd, NamedLink } from '../../../../../components';

import css from './AvailabilitiesIndicator.module.css';
import {useSelector} from "react-redux";
import {pathOr} from "ramda";
import {moment} from "../../../../../util/dates";

const availabilityData = {
  AVAILABLE: {
    label: "availability.available",
    textColor: "#1E7E34",
    backgroundColor: "#D4EDDA"
  },
  AVAILABLE_ONLY_FOR_EVENTS: {
    label: "availability.available_only_for_events",
    textColor: "#0C5460",
    backgroundColor: "#D1ECF1"
  },
  NOT_AVAILABLE: {
    label: "availability.not_available",
    textColor: "#721C24",
    backgroundColor: "#F8D7DA"
  },
  AVAILABLE_PARTIALLY: {
    label: "availability.available_partially",
    textColor: "#856404",
    backgroundColor: "#FFF3CD"
  },
  NOT_CONFIRMED: {
    label: "availability.not_confirmed",
    textColor: "#721C24",
    backgroundColor: "#F8D7DA"
  }
};

const pagesWithBottomActions = [
  'AccountPersonalInfosPage',
  'AccountProfilePage',
  'CalendarPage',
  'EditListingPage',
  'InboxPage',
  'ListingPage',
  'SearchPage',
  'TransactionPage',
];

const AvailabilitiesIndicator = (props) => {
  const {
    className,
    currentPage,
    intl,
    isMobile,
    show,
  } = props;
  const user = useSelector(state => state.user);
  const availabilitiesHistory = pathOr({}, ['currentUser', 'attributes', 'profile', 'privateData', 'availabilitiesHistory'], user);
  const nextWeek = moment().add(1, 'week').format('WW[_]YYYY');
  const nextAvailability = pathOr('NOT_CONFIRMED', [nextWeek, 'choice'], availabilitiesHistory);
  const userAvailabilityData = availabilityData[nextAvailability];
  console.log('user', nextAvailability)
  const label = intl.formatMessage({ id: userAvailabilityData.label })

  const handleRender = (node) => {
    if (isMobile) {
      return ReactDOM.createPortal((
        <SlideAnimation inProps={show} from="bottom" mountOnEnter unmountOnExit>
          {node}
        </SlideAnimation>
      ), document.body);
    } else {
      return (
        <FadeAnimation inProps={show} mountOnEnter unmountOnExit>
          {node}
        </FadeAnimation>
      )
    }
  };
  const addListingLinkText = intl.formatMessage({
    id: currentPage === 'SimulatorPage' ? 'Topbar.addListingLink' : 'Topbar.simulatorLink'
  });
  const classes = classNames(css.root, className, {
    [css.mobileElevated]: isMobile && pagesWithBottomActions.includes(currentPage),
    [css.uniqueButton]: currentPage === 'SimulatorPage',
  });
  console.log('currentPage',currentPage)
  const getNextAvailabilityChoice = () => {
    return "Prochaine disponibilité non confirmé"
  }

  const hideOnMobile = isMobile && nextAvailability !== 'NOT_CONFIRMED' && currentPage !== 'ManageListingsPage';


  return (isServer() || hideOnMobile) ? null : handleRender(
    <NamedLink
      className={classes}
      style={{background: userAvailabilityData.backgroundColor }}
      name={'AvailabilitiesPage'}
    >
      <div className={css.circle} style={{background: userAvailabilityData.textColor }}/>
      <span style={{color: userAvailabilityData.textColor }}>{label}</span>
    </NamedLink>
  )
};

export default AvailabilitiesIndicator;
